import React from "react";
import { Calendar, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TodaySchedule = ({ schedule = [] }) => {
  const navigate = useNavigate();

  const statusConfig = {
    live: { label: "Live Now", cls: "live" },
    completed: { label: "Completed", cls: "completed" },
    upcoming: { label: "Upcoming", cls: "upcoming" },
  };

  return (
    <div className="db-card">
      <div className="db-card-head">
        <div className="db-card-head-left">
          <div className="db-card-icon blue"><Calendar size={18} /></div>
          <div>
            <div className="db-card-title">Today's Schedule</div>
            <div className="db-card-subtitle">{schedule.length} classes scheduled</div>
          </div>
        </div>
        <button className="db-card-link" onClick={() => navigate("/batches")}>
          View All <ArrowRight size={12} />
        </button>
      </div>
      <div className="db-card-body">
        {schedule.map((item) => {
          const cfg = statusConfig[item.status] || statusConfig.upcoming;
          return (
            <div key={item.id} className="db-schedule-item">
              <div className="db-schedule-info">
                <div className="db-schedule-batch">
                  {item.batch}
                  <span className={`db-schedule-badge ${cfg.cls}`}>{cfg.label}</span>
                </div>
                <div className="db-schedule-course">{item.course}</div>
              </div>
              <div className="db-schedule-right">
                <div className="db-schedule-time">{item.time}</div>
                <div className="db-schedule-meta">{item.instructor} · {item.students} students</div>
              </div>
            </div>
          );
        })}
        {schedule.length === 0 && <div className="text-muted text-center py-3" style={{ fontSize: "0.8125rem" }}>No classes today</div>}
      </div>
    </div>
  );
};

export default TodaySchedule;
